// @ts-nocheck
// Polyfill for ReactDOM.findDOMNode removed in React 19
// ------------------------------------------------------
// React 19 finally removed the long-deprecated `findDOMNode` API. Some browser-
// only libraries (e.g. `react-quill`) still rely on it.  A proper migration
// would fork / upgrade the library, but for now we only need the subset they
// use: converting a ref or component instance (which for those libs is always
// an HTML element or already a DOM node) back into the underlying element.
//
// We attach a best-effort, minimal shim when running **on the web** so native
// bundles remain untouched.
// This avoids runtime crashes like:
//   TypeError: ReactDOM.findDOMNode is not a function
// ------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore – react-dom will be present in web bundles only
import * as ReactDOM from 'react-dom';

// Only patch if it's missing (React <19 still defines it)
if (typeof (ReactDOM as any).findDOMNode !== 'function') {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore – dynamic attach
  (ReactDOM as any).findDOMNode = (componentOrElement: any): Element | null => {
    if (!componentOrElement) return null;

    // If a plain DOM element is passed, return it directly.
    if (componentOrElement instanceof Element) return componentOrElement;

    // If it's a ref object ({ current: ... })
    if (
      typeof componentOrElement === 'object'
      && 'current' in componentOrElement
      && componentOrElement.current instanceof Element
    ) {
      return componentOrElement.current;
    }

    // Unsupported input – return null to mimic old behaviour.
    return null;
  };
}

// Also patch the ESModule default wrapper used by transpilers like TS/ESM
if ((ReactDOM as any).default && typeof (ReactDOM as any).default.findDOMNode !== 'function') {
  (ReactDOM as any).default.findDOMNode = (ReactDOM as any).findDOMNode;
}
